import { parseCityData, type CityIndex } from '../utils/cityIndex';

/**
 * The world city index, loaded ON DEMAND. ⚠️ The data is ~1.4 MB of text (710 KB
 * over the wire), so it is a dynamic import: only a reader who opens Settings →
 * Location (or asks for their location) ever downloads it, and the app's own
 * bundle is unchanged. Parsed once per session.
 */
let cached: Promise<CityIndex> | null = null;

export function loadCityIndex(): Promise<CityIndex> {
  if (!cached) {
    cached = import('./worldCities.data')
      .then((m) => parseCityData(m.default))
      .catch((err) => {
        cached = null; // a failed load must not poison the next attempt
        throw err;
      });
  }
  return cached;
}
